// extracted by mini-css-extract-plugin
export var link = "_tx-0";